/* eslint-disable prefer-template */
<template>
  <div class="fina-main">
    <div class="search-form">
      <el-form
        inline
        :model="originData"
        ref="searchForm"
      >
        <el-form-item
          label="产品代码:"
          prop="prdCode"
        >
          <el-input
            placeholder="请输入"
            v-model.trim="originData.prdCode"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="产品名称:"
          prop="prdName"
        >
          <el-input
            placeholder="请输入"
            v-model.trim="originData.prdName"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="起购金额(元):"
          class="age-container"
        >
          <el-input
            placeholder="请输入"
            onkeyup="value=value.replace(/[^0-9]/g,'')"
            v-model="originData.purchaseAmountsFloor"
          ></el-input>至<el-input
            placeholder="请输入"
            onkeyup="value=value.replace(/[^0-9]/g,'')"
            v-model="originData.purchaseAmountsCeiling"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="投资期限(天):"
          class="age-container"
        >
          <el-input
            placeholder="请输入"
            onkeyup="value=value.replace(/[^0-9]/g,'')"
            v-model="originData.investTermFloor"
          ></el-input>至<el-input
            placeholder="请输入"
            onkeyup="value=value.replace(/[^0-9]/g,'')"
            v-model="originData.investTermCeiling"
          ></el-input>
        </el-form-item>
        <el-form-item label="收益类型:">
          <el-select
            clearable
            placeholder="请选择"
            v-model="originData.yieldType"
          >
            <el-option
              v-for="item in incomeType"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="风险等级:">
          <el-select
            clearable
            placeholder="请选择"
            v-model="originData.riskLevel"
          >
            <el-option
              v-for="item in riskLevel"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="showSearches==false">
          <el-button
            type="text"
            @click="showSearch"
          >更多查询条件</el-button>
          <i
            class="el-icon-arrow-down el-icon--right"
            style="color:#409EFF"
          ></i>
        </el-form-item>
        <div
          style="display:inline;"
          v-if="showSearches"
        >
          <el-form-item label="产品状态:">
            <el-select
              clearable
              placeholder="请选择"
              v-model="originData.status"
            >
              <el-option
                v-for="item in prdStatus"
                :key="item.dictValue"
                :label="item.dictName"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="上下架状态:">
            <el-select
              clearable
              placeholder="请选择"
              v-model="originData.sellStatus"
            >
              <el-option
                v-for="item in isSale"
                :key="item.id"
                :label="item.status"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否置顶:">
            <el-select
              clearable
              placeholder="请选择"
              v-model="originData.topFlag"
            >
              <el-option
                v-for="item in isTop"
                :key="item.id"
                :label="item.status"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="运作模式:">
            <el-select
              clearable
              placeholder="请选择"
              v-model="originData.operationMode"
            >
              <el-option
                v-for="item in processPattern"
                :key="item.dictValue"
                :label="item.dictName"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="投资资产类型:">
            <el-select
              clearable
              placeholder="请选择"
              v-model="originData.investAssetClass"
            >
              <el-option
                v-for="item in investmentsType"
                :key="item.dictValue"
                :label="item.dictName"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="text"
              @click="retract"
            >收起</el-button>
            <i
              class="el-icon-arrow-up el-icon--right"
              style="color:#409EFF"
            ></i>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="flex">
      <div>
        <el-button
          size="small"
          type="primary"
          @click="handleQueryClick"
        >查询</el-button>
        <el-button
          size="small"
          @click="reset"
        >清空查询条件</el-button>
      </div>
    </div>
    <div>
      <el-table
        border
        highlight-current-row
        :data="tableData"
        style="width: 100%"
        @sort-change="getOrder"
        ref="sorttable"
      >
        <template slot="empty">
          {{emptyText}}
        </template>
        <el-table-column
          label="产品代码"
          width="150"
          v-if="functionList.indexOf(
          '326983565677662208')!='-1'"
        >
          <template slot-scope="scope">
            <span
              class='prdCode'
              @click="addTask(scope.row)"
              v-html='scope.row.prdCode'
            >
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="产品代码"
          width="130"
          v-else
        >
          <template slot-scope="scope">
            <span v-html='scope.row.prdCode'>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="prdName"
          label="产品名称"
          width="180"
        >
          <template slot-scope="scope">
            {{scope.row.prdName}}
          </template>
        </el-table-column>
        <el-table-column
          prop="statusRes"
          label="产品状态"
          width="100"
        >
          <template slot-scope="scope">
            <span
              class="speshow"
              v-if="scope.row.statusRes==='停售'||scope.row.statusRes==='售罄'"
            >{{scope.row.statusRes}}</span>
            <span v-else>{{scope.row.statusRes}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sellStatus"
          label="上下架状态"
          width="120"
        >
          <template slot-scope="scope">
            <span
              class="speshow"
              v-if="parseInt(scope.row.sellStatus)===0"
            >下架</span>
            <span v-if="parseInt(scope.row.sellStatus)===1">上架</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="topFlag"
          label="是否置顶"
          width="80"
        >
          <template slot-scope="scope">
            <span v-if="parseInt(scope.row.topFlag)===0">否</span>
            <span
              v-if="parseInt(scope.row.topFlag)===1"
              class="spespan"
            >是</span>
          </template>
        </el-table-column>
        <el-table-column
          style="text-align:right"
          width="200"
          prop="purchaseAmounts"
          label="起购金额(元)"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.purchaseAmounts|formatCurrency}}
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          prop="investTerm"
          label="投资期限(天)"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.investTerm}}
          </template>
        </el-table-column>
        <el-table-column
          width="180"
          prop="expAnnualYield"
          label="预期年化收益率"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.expAnnualYield}}
          </template>
        </el-table-column>
        <el-table-column
          width="180"
          prop="performanceCriterion"
          label="业绩比较基准"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.performanceCriterion}}
          </template>
        </el-table-column>
        <el-table-column
          width="180"
          prop="weekAnnualYield"
          label="七日年化收益率"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.weekAnnualYield|getFloat}}%
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="newsetNetValue"
          label="最新净值"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.newsetNetValue|getFloat}}
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          prop="remainAmounts"
          label="可售余额"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.remainAmounts|formatCurrency}}
          </template>
        </el-table-column>
        <el-table-column
          prop="yieldType"
          label="收益类型"
          width="200"
        >
          <template slot-scope="scope">
            {{scope.row.yieldTypeRes}}
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="riskLevel"
          label="风险等级"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.riskLevelRes}}
          </template>
        </el-table-column>
        <el-table-column
          prop="operationModeRes"
          label="运作模式"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="investAssetClass"
          label="投资资产类型"
          width="200"
        >
          <template slot-scope="scope">
            {{scope.row.investAssetClassRes}}
          </template>
        </el-table-column>
        <el-table-column
          prop="ipoStartDate"
          label="募集开始日"
          width="200"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.ipoStartDate | formatToM}}
          </template>
        </el-table-column>
        <el-table-column
          prop="ipoEndDate"
          label="募集结束日"
          width="200"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.ipoEndDate | formatToM}}
          </template>
        </el-table-column>
        <el-table-column
          prop="establishDate"
          label="产品成立日"
          width="200"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.establishDate | formatDate}}
          </template>
        </el-table-column>
        <el-table-column
          prop="expireDate"
          label="产品到期日"
          width="200"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.expireDate | formatDate}}
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="管理信息修改时间"
          width="200"
          sortable='custom'
          :sort-orders="orderShow"
        >
          <template slot-scope="scope">
            {{scope.row.updateTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          prop="updateUserName"
          label="管理信息修改人"
        >
         <template slot-scope="scope">
          {{scope.row.updateUserName }}{{scope.row.updateUserWordNo |filterWorkerNo}}
        </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="230px"
        >
          <template slot-scope="scope">
            <div class="feature-container">
              <span
                v-if="functionList.indexOf(
          '326983565677662208')!='-1'"
                class="button--blue"
                @click="addTask(scope.row)"
              >产品详情</span>
              <span
                class="button--blue"
                v-if="scope.row.topFlag==='0'&&functionList.indexOf(
          '326983429484417024')!='-1'"
                @click=" isDisables(scope.row ,'1')"
              >置顶</span>
              <span
                class="button--blue"
                v-if="scope.row.topFlag==='1'&&functionList.indexOf(
          '326983429484417024')!='-1'"
                @click=" isDisables(scope.row ,'0')"
              >取消置顶</span>
              <span
                class="button--green"
                v-if="scope.row.sellStatus==='0'&&functionList.indexOf(
          '326983273347256320')!='-1'"
                @click=" isSales(scope.row ,'1')"
              >上架</span>
              <span
                class="button--red"
                v-if="scope.row.sellStatus==='1'&&functionList.indexOf(
          '326983273347256320')!='-1'"
                @click=" isSales(scope.row ,'0')"
              >下架</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
  </div>
</template>
<script>
import { getFunctionList, addNav, getPagingData } from '@/mixins';

export default {
  name: 'financialPrds',
  mixins: [getFunctionList, addNav, getPagingData],

  data() {
    const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      emptyText: this.$LS.empty,
      // 初始数据
      originData: {
        prdCode: '',
        prdName: '',
        purchaseAmountsFloor: null,
        purchaseAmountsCeiling: null,
        investTermFloor: null,
        investTermCeiling: null,
        yieldType: '',
        riskLevel: '',
        status: '',
        sellStatus: '',
        topFlag: '',
        operationMode: '',
        investAssetClass: '',
        userId: sessionData.userId,
        loginOrgnCode: sessionData.orgnCode,
        orgnInheritSign: sessionData.orgnInheritSign,
        orderFlag: '0',
        orderKey: '13',
      },
      // 查询数据
      searchParam: {

        prdCode: '',
        prdName: '',
        purchaseAmountsFloor: null,
        purchaseAmountsCeiling: null,
        investTermFloor: null,
        investTermCeiling: null,
        yieldType: '',
        riskLevel: '',
        status: '',
        sellStatus: '',
        topFlag: '',
        operationMode: '',
        investAssetClass: '',
        userId: sessionData.userId,
        loginOrgnCode: sessionData.orgnCode,
        orgnInheritSign: sessionData.orgnInheritSign,
        orderFlag: '0',
        orderKey: '13',
      },
      showSearches: false,
      orderMap: {
        descending: '0', // 倒序
        ascending: '1', // 正序
      },
      orderFlagMap: {
        purchaseAmounts: '1',
        investTerm: '2',
        expAnnualYield: '3',
        performanceCriterion: '4',
        weekAnnualYield: '5',
        newsetNetValue: '6',
        remainAmounts: '7',
        riskLevel: '8',
        ipoStartDate: '9',
        ipoEndDate: '10',
        establishDate: '11',
        expireDate: '12',
        updateTime: '13',
      },
      orderShow: ['descending', 'ascending', null],
      // 表格数据
      tableData: [],
      // 功能集合
      functionList: [],
      // 总数
      sumCount: 0,
      // 当前页数
      currentPage: 1,
      // 每页数量
      pageSize: 10,
      incomeType: [],
      riskLevel: [],
      prdStatus: [],
      processPattern: [],
      investmentsType: [],
      isSale: [
        {
          id: 0,
          status: '下架',
        },
        {
          id: 1,
          status: '上架',
        },
      ],
      isTop: [
        {
          id: 0,
          status: '否',
        },
        {
          id: 1,
          status: '是',
        },
      ],
    };
  },
  filters: {
    getFloat(number) {
      // eslint-disable-next-line no-restricted-properties
      let result = Math.round(number * Math.pow(10, 4)) / Math.pow(10, 4);
      result = Number(result).toFixed(4);
      return result;
    },
    filterWorkerNo(number) {
      if (number) {
        return `(${number})`;
      }
      return '';
    },
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
  },
  mounted() {
    this.queryIncomeType();
    this.queryRiskLevel();
    this.queryPrdStatust();
    this.queryProcessPattern();
    this.queryInvestmentsType();
  },
  methods: {
    // 获取表格数据
    getTableData() {
      this.getPagingData(this.$API.financialListQuery);
    },
    // 更多查询条件
    showSearch() {
      this.showSearches = true;
    },
    // 收起
    retract() {
      this.showSearches = false;
    },
    // 查询按钮
    handleQueryClick() {
      this.$refs.sorttable.clearSort();
      this.searchParam = {
        ...this.originData,
      };
      this.pageNo = 1;
      this.getTableData();
    },
    // 重置按钮
    reset() {
      this.$refs.sorttable.clearSort();
      const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
      // this.currentPage = 1;
      this.originData.userId = sessionData.userId;
      this.originData.loginOrgnCode = sessionData.orgnCode;
      this.originData.orgnInheritSign = sessionData.orgnInheritSign;
      this.originData.orderFlag = '0';
      this.originData.orderKey = '13';
    },
    // 字典获取收益类型
    queryIncomeType() {
      const parames = {
        data: {
          dictTypeCode: 'financeYieldType',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=1`, parames).then((res) => {
        this.incomeType = res.data.list;
      });
    },
    // 字典获取风险等级
    queryRiskLevel() {
      const parames = {
        data: {
          dictTypeCode: 'prdRiskLevel',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=2`, parames).then((res) => {
        this.riskLevel = res.data.list;
      });
    },
    // 字典获取产品状态
    queryPrdStatust() {
      const parames = {
        data: {
          dictTypeCode: 'financePrdStatus',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=3`, parames).then((res) => {
        this.prdStatus = res.data.list;
      });
    },
    // 字典获取运作模式
    queryProcessPattern() {
      const parames = {
        data: {
          dictTypeCode: 'financeOperationMode',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=4`, parames).then((res) => {
        this.processPattern = res.data.list;
      });
    },
    // 字典获取投资资产类型
    queryInvestmentsType() {
      const parames = {
        data: {
          dictTypeCode: 'financeInvestAssetType',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=5`, parames).then((res) => {
        this.investmentsType = res.data.list;
      });
    },
    // 列表排序
    getOrder(orders) {
      console.log(orders);
      const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      this.searchParam = {
        ...this.searchParam,
        orderFlag: this.orderMap[orders.order] || null,
        orderKey: this.orderFlagMap[orders.prop] || null,
        userId: sessionData.userId,
        loginOrgnCode: sessionData.orgnCode,
        orgnInheritSign: sessionData.orgnInheritSign,
      };
      if (this.currentPage === 1) {
        this.getTableData();
      } else {
        this.currentPage = 1;
      }
    },
    // 是否置顶
    isDisables(row, status) {
      let str = '';
      const name = row.prdName;
      if (status === '1') {
        str = '置顶';
        this.$confirm(`确定要${str}"${name}"?`, '提示', {
          confirmButtonText: `${str}`,
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(() => {
            this.disables(row, status);
          })
          .catch(() => {});
      } else if (status === '0') {
        str = '取消置顶';
        this.$confirm(`确定要${str}"${name}"?`, '提示', {
          confirmButtonText: `${str}`,
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(() => {
            this.disables(row, status);
          })
          .catch(() => {});
      }
    },
    // 修改置顶状态
    disables(row, status) {
      const getsessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      const params = {
        data: {
          topFlag: status,
          prdCode: row.prdCode,
          updateUserid: getsessionData.userId,
          userName: getsessionData.userName,
          loginOrgnCode: getsessionData.orgnCode,
          loginOrgnName: getsessionData.orgnName,
        },
      };
      this.$_post(this.$API.changeTopStatus, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.currentPage = 1;
          this.getTableData();
          this.$message.success('成功');
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 是否上下架
    isSales(row, status) {
      let str = '';
      const name = row.prdName;
      if (status === '1') {
        str = '上架';
        this.$confirm(`确定要${str}"${name}"?`, '提示', {
          confirmButtonText: `${str}`,
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(() => {
            this.sales(row, status);
          })
          .catch(() => {});
      } else if (status === '0') {
        str = '下架';
        this.$confirm(`确定要${str}"${name}"?`, '提示', {
          confirmButtonText: `${str}`,
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(() => {
            this.sales(row, status);
          })
          .catch(() => {});
      }
    },
    // 修改上下架状态
    sales(row, status) {
      const getsessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      const params = {
        data: {
          sellStatus: status,
          prdCode: row.prdCode,
          updateUserid: getsessionData.userId,
          userName: getsessionData.userName,
          loginOrgnCode: getsessionData.orgnCode,
          loginOrgnName: getsessionData.orgnName,
        },
      };
      this.$_post(this.$API.changeSaleStatus, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.currentPage = 1;
          this.getTableData();
          this.$message.success('成功');
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 产品详情
    addTask(item) {
      this.addNav({
        name: '产品详情',
        path: '/financiaPrdDetail',
        query: {
          prdCode: item.prdCode,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.prdCode {
  color: #54a6de;
  cursor: pointer;
  border-bottom: 1px solid #54a6de;
}
.el-tabs__content {
  height: 400px;
  overflow: auto;
}
.spespan {
  color: #02bb6f;
}
.speshow {
  color: #a2a7b3;
}
.el-textarea {
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #f5f7fa;
  }
}
.search_input .el-col {
  margin-top: 10px;
}
.span_point {
  color: #f56c6c;
  margin-left: 10px;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.search-form .date-container .el-form-item__content .el-input {
  width: 200px;
}
.age-container .el-input {
  width: 200px;
}
</style>
<style lang="scss">
.fina-main {
  th:nth-of-type(6),
  th:nth-of-type(12) {
    text-align: right;
  }
  td:nth-child(6),
  td:nth-child(12) {
    text-align: right;
  }
}
.search_input .el-form-item.is-success .el-input__inner {
  border-color: #dcdfe6;
}
</style>
